import { createSlice } from "@reduxjs/toolkit"

const permissionSlice = createSlice({
  name: "permission",
  initialState: {
    permissions: [],
    permission: null,
    groupedPermissions: [],
    loading: false,
    error: null,
  },
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setPermissions: (state, action) => {
      state.permissions = action.payload
      state.loading = false
      state.error = null
    },
    setPermission: (state, action) => {
      state.permission = action.payload
      state.loading = false
      state.error = null
    },
    setGroupedPermissions: (state, action) => {
      state.groupedPermissions = action.payload
      state.loading = false
      state.error = null
    },
    resetState: state => {
      state.permissions = []
      state.permission = null
      state.groupedPermissions = []
      state.loading = false
      state.error = null
    },
  },
})

export const permissionAction = permissionSlice.actions
export default permissionSlice.reducer
